import moment from 'moment';
import { FiltersState, OperationType } from '../types';

type PresetRangeSet = { [key: string]: any };

export const defaultFilterState: FiltersState = {
  isTankMixShown: false,
  dateRange: { start: moment().subtract(1, 'year'), end: moment() },
  operationType: OperationType.ALL,
};

export const getPresetDateRanges: (t: (key: string) => string) => PresetRangeSet = (t) => {
  return {
    [t('resource-mapper.past_day')]: [moment().subtract(1, 'day'), moment()],
    [t('resource-mapper.past_week')]: [moment().subtract(1, 'week'), moment()],
    [t('resource-mapper.past_month')]: [moment().subtract(1, 'month'), moment()],
    [t('resource-mapper.past_6_months')]: [moment().subtract(6, 'months'), moment()],
    [t('resource-mapper.past_year')]: [moment().subtract(1, 'year'), moment()],
  };
};

export const MAX_SUPPORTED_YEAR = 3000;
